<div class="sidebar" [class.collapsed]="isCollapsed">
  <div class="sidebar-header">
    <span class="logo" *ngIf="isMobile || (!isMobile && !isCollapsed)" title="Transparência da Educação">
      <img src="../../../../assets/transparencia-images/logo-te.png" class="img-fluid">
    </span>
    <span class="title" *ngIf="!isCollapsed">Administrativo</span>

    <button class="toggle-btn" (click)="toggleSidebar()" [disabled]="isMobile">
      <i-lucide name="menu" color="#fff"></i-lucide>
    </button>
  </div>

  <nav class="menu">
    <a class="menu-item" routerLink="/adm/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <i-lucide name="blocks" title="Módulos"></i-lucide>
      <span *ngIf="!isCollapsed">Módulos</span>
    </a>
    @if (exibirMenuMaster) {
      <a class="menu-item" routerLink="/adm/imap/cliente" routerLinkActive="active">
        <i-lucide name="shield" title="Cadastro de Usuários"></i-lucide>
        <span *ngIf="!isCollapsed">Cadastro de Clientes</span>
      </a>

      <a class="menu-item" routerLink="/adm/imap/modulo" routerLinkActive="active">
        <i-lucide name="book-open" title="Gerenciador de Módulos"></i-lucide>
        <span *ngIf="!isCollapsed">Gerenciador de Módulos</span>
      </a>

      <a class="menu-item" routerLink="/adm/imap/usuario" routerLinkActive="active">
        <i-lucide name="users" title="Cadastro de Usuários"></i-lucide>
        <span *ngIf="!isCollapsed">Cadastro de Usuários</span>
      </a>
    }

    <!-- <a class="menu-item text-portal" routerLink="/transparencia/home" title="Acessar o portal">
      <i-lucide name="globe"></i-lucide>
      <span *ngIf="!isCollapsed">Portal da Transparência</span>
    </a> -->
  </nav>
</div>